<template>
  <v-main>
    <v-container fluid>
      <div class="breadcrumbs-container">
        <Breadcrumbs />
      </div>
      <div class="flex flex-col space-y-0 -space-x-12">
        <section class="flex space-x-4">
          <div class="w-full md:w-2/3 flex flex-col items-center h-full">
            <iframe
              class="w-full"
              src="http://www.localhost:8085"
              sandbox="allow-scripts allow-same-origin"
            ></iframe>
            <v-btn color="primary" dark @click="$router.go(-1)">{{ $t('back') }}</v-btn>
          </div>
        </section>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import Breadcrumbs from '@/components/charts/Breadcrumbs.vue';

export default {
  name: 'PlantUml',
  components: {
    Breadcrumbs,
  },
};
</script>

<style scoped>
iframe {
  width: 100%;
  max-width: 100%;
  height: 590px;
}
.container--fluid {
  max-width: 70% !important;
}
.breadcrumbs-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 40px;
}

.breadcrumbs-container .v-breadcrumbs {
  background-color: #ffffff;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 800;
}
</style>
